import { Filters } from '../../../model/Filters'

const all = ['question_templates']
const lists = [...all, 'list']
const list = (filters?: Filters) => [...lists, filters]
const detail = (id: number) => [...all, id]

export const questionTemplatesKeys = {
  all,
  lists,
  list,
  detail,
}
